import type { ClientListSortColumn, SortOrder } from "Infrastructure/Api/Api";

export const CLIENTS_QUERY_KEYS = {
  all: ["CLIENTS"] as const,
  list: (
    offset?: number,
    limit?: number,
    searchQuery?: string | null,
    partnerIDs?: string[],
    sortBy?: ClientListSortColumn,
    sortOrder?: SortOrder,
  ) =>
    [
      ...CLIENTS_QUERY_KEYS.all,
      "LIST",
      offset,
      limit,
      searchQuery,
      partnerIDs,
      sortBy,
      sortOrder,
    ] as const,
  detail: (clientID: string) =>
    [...CLIENTS_QUERY_KEYS.all, "DETAIL", clientID] as const,
  documents: (clientID: string) =>
    [...CLIENTS_QUERY_KEYS.all, "DOCUMENTS", clientID] as const,
} as const;
